import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { eventsQueryKeys } from 'features/events';
import { NotificationApiService } from 'features/notification/api/notification-api.service';
import { queryClient } from 'providers';



const { moveSelectedUser } = NotificationApiService();

export const useMoveSelectedUserList = () => {
    const { message } = App.useApp();

    return useMutation(
        (payload: any) => {
            return moveSelectedUser(payload);
        },
        {
            onError: (error: any) => {
                let uiMessage = handleError(error);
                if (error.response && error.response.data && error.response.data.ResponseMessage) {
                    uiMessage = error.response.data.ResponseMessage;
                }

                message.error(uiMessage);
            },
            onSuccess: (data:any) => {

               
                const { ResponseMessage } = data;
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                if (data.ResponseStatus == 0) {
                    message.error(ResponseMessage)
                } else {
                    message.success(data?.ReponseMessage?(data?.ReponseMessage):"Successfully moved selected user.");
                }
            },
        },
    );
};

